export const STAGES = ['active', 'in_talks', 'on_hold', 'married', 'divorced', 'archived'];
export const STAGE_LABELS = {
    active: 'Active',
    in_talks: 'In Talks',
    on_hold: 'On Hold',
    married: 'Married',
    divorced: 'Divorced',
    archived: 'Archived',
};
/** Stages hidden from the default dashboard view. */
export const STAGES_HIDDEN_BY_DEFAULT = ['married', 'divorced', 'archived'];
export const GENDERS = ['Male', 'Female'];
export const MARITAL_STATUSES = [
    'Never Married', 'Divorced', 'Widowed', 'Separated',
];
export const PROFESSIONAL_DETAILS = [
    'Employed', 'Self Employed', 'Business', 'Student', 'Not Working', 'Other',
];
export const DESCRIBES_YOU = [
    'Religious / practising', 'Flexible / balanced', 'Modern / liberal',
    'Career-oriented', 'Homemaker-focused', 'Prefer not to say',
];
export const YES_NO_UNSURE = ['Yes', 'No', 'Not sure'];
export const SORT_OPTIONS = [
    { value: 'newest', label: 'Newest first' },
    { value: 'oldest', label: 'Oldest first' },
    { value: 'name_asc', label: 'Name A–Z' },
    { value: 'name_desc', label: 'Name Z–A' },
    { value: 'age_asc', label: 'Youngest first' },
    { value: 'age_desc', label: 'Oldest by age' },
    { value: 'height_asc', label: 'Shortest first' },
    { value: 'height_desc', label: 'Tallest first' },
    { value: 'updated', label: 'Recently updated' },
    { value: 'starred', label: 'Starred first' },
];
export const SORT_VALUES = SORT_OPTIONS.map((o) => o.value);
//# sourceMappingURL=enums.js.map